<template>
    <div class="pr-10 pl-10" >
        <v-text-field :key="key" v-model="value.variableKey" :label="'Variável'"></v-text-field>

        <v-text-field v-model="value.variableInternal" :label="'Variável Interna'"></v-text-field>

        <!-- <v-text-field v-model="value.variableKey" :label="$t('entities.regTypeFields.props.variableKey')" type="text"></v-text-field>

        <v-select v-model="value.variableType" item-text="value" :items="$typesDataNative" item-value="key"
            :label="$t('entities.regTypeFields.props.variableType')"></v-select>

        <v-checkbox v-model="value.readOnly" :label="$t('entities.regTypeFields.props.readOnly')" />

        <v-select v-model="value.behavior" item-text="value" :items="$behaviors" item-value="key"
            :label="$t('entities.regTypeFields.props.behavior')" clearable></v-select>

        <v-select v-model="value.readType" item-text="value" :items="$readTypes" item-value="value"
            :label="$t('entities.regTypeFields.props.readType')" clearable></v-select>
        <v-checkbox v-model="value.required" :label="$t('entities.regTypeFields.props.required')" /> -->
    </div>
</template>

<script>
export default {
    props: ["isOpen", "item"],
    name: 'resourceVariableDialog',
    data() {
        return {
            dialog: false,
            value: {
                // field: this.item?.field || "",
                // seq: this.item?.seq || "",
                // variableKey: this.item?.variableKey || "",
                // variableType: this.item?.variableType || "",
                // readOnly: this.item?.readOnly || null,
                // behavior: this.item?.behavior || null,
                // required: this.item?.required || null,
                variableKey: this.item?.variableKey,
                variableInternal: this.item?.variableInternal,
                id: this.item?.id || null,
                code: this.item?.code || null,
            },
            obj: {},
            key: 0
        }
    },
    async created() {
        if(!this.value.code){
            this.value.code = await this.getAutoInc()
        }
    },
    methods: {
        async getAutoInc() {
            let res = await this.$http.post(`autoinc?collection=Variable&type=`);
            if (res.success) return res.data;
        },
    },
    watch: {
        value: {
            handler(newValues){
                this.$emit("value", newValues)
            },
            deep: true
        },

        async isOpen(value) {
            console.log("ITEM >>> ", this.item)
            if (value) {
                this.value = {
                    // field: this.item?.field || "",
                    // seq: this.item?.seq || "",
                    // variableKey: this.item?.variableKey || "",
                    // variableType: this.item?.variableType || "",
                    // readOnly: this.item?.readOnly || "",
                    // behavior: this.item?.behavior || "",
                    // required: this.item?.required || "",
                    variableKey: this.item?.variableKey,
                    variableInternal: this.item?.variableInternal,
                    id: this.item?.id || null,
                    code: this.item?.code || null,
                }

                if (!this.value.code) {
                    this.value.code = await this.getAutoInc()
                }

                this.$forceUpdate()
            }
        }
    }
}
</script>

<style></style>